import $ from 'jquery';
import React from 'react';
import I18n from 'app/i18n';
import {modalAlert} from 'app/utils/modals/popups';
import {Auth} from './auth_popup';
import Captcha from './captcha';
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3';
import SmartLoader from 'app/components/reusable/SmartLoader';
import {toastError} from 'app/components/toasts/liteToast';
import InputError from 'app/components/deposit/InputError';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

class ForgotPassword extends React.PureComponent {
    state = {captcha_id: undefined, emailError: null, error: null, submitting: false, success: null, useRecaptchaV2: false};

    captchaError() {
        return this.state.error && this.state.captcha;
    }

    errorMessage(error) {
        if (typeof error.responseJSON.errors === 'object') {
            return Object.values(JSON.parse(error.responseText).errors)[0][0];
        }
        return error.responseJSON.errors;
    }

    validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;
        return emailRegex.test(email);
    }

    remindPassword = e => this.submitForm(e, {captchaAction: 'forgot_password', url: '/egb_users/password'});

    sendMagicLink = e => this.submitForm(e, {captchaAction: 'magic_link', url: '/egb_users/magic_link'});

    submitForm = async (e, {captchaAction, url}) => {
        e.preventDefault();

        const email = this.formRef.querySelector('input[name="egb_user[email]"]').value;

        if (!email || email.trim() === '') {
            this.setState({emailError: I18n.t('invalid_email_empty')});
            return;
        }

        if (!this.validateEmail(email)) {
            this.setState({emailError: I18n.t('invalid_email')});
            return;
        }

        if (this.state.submitting) {
            return;
        }

        this.setState({emailError: null, error: null, submitting: true});

        let recaptchaToken = null;
        if (this.state.useRecaptchaV2) {
            recaptchaToken = null;
        } else {
            try {
                const {executeRecaptcha} = this.props.googleReCaptchaProps || {};
                recaptchaToken = executeRecaptcha ? await executeRecaptcha(captchaAction) : null;
            } catch (error) {
                toastError(I18n.t('global.error_text_captcha'));
                this.setState({submitting: false});
                return;
            }
        }

        let data = `${$(this.formRef).serialize()}&use_recaptcha_v2=${this.state.useRecaptchaV2}`;
        if (!this.state.useRecaptchaV2 && recaptchaToken) {
            data += `&g-recaptcha-response=${recaptchaToken}`;
        }

        $.ajax({
            data,
            dataType: 'JSON',
            statusCode: {
                422: error => {
                    toastError(this.errorMessage(error));
                    this.setState({
                        captcha: error.responseJSON.captcha,
                        submitting: false,
                        useRecaptchaV2: error.responseJSON.captcha || false
                    });
                },
                500: () => {
                    toastError(I18n.t('server_error_try_later'));
                    this.setState({error: I18n.t('server_error_try_later'), submitting: false});
                }
            },
            success: response => {
                if (response.success) {
                    this.setState({success: response.text});
                } else if (response.error) {
                    toastError(response.text);
                    this.setState({error: response.text});
                } else {
                    modalAlert(response.text);
                }
                this.setState({submitting: false});
            },
            type: 'POST',
            url
        });
    };

    setFormRef = x => {
        this.formRef = x;
    };

    render() {
        const {success, error, submitting, useRecaptchaV2, emailError} = this.state;
        return success
            ? <div className="text-center forgot-password">{success}</div>
            : <form ref={this.setFormRef}
                className={`popup-form forgot-password${error ? ' popup-form--error' : ''}`}
                onKeyUp={e => Auth.clearFiledError(this, e)} onSubmit={this.remindPassword}>
                <div className="popup-form__row">
                    <a className="popup-form__back" href="#" onClick={this.props.back} style={{marginLeft: 0}}>
                        <SpriteIcon name="#svg-back" size={{height: 8, width: 5}}/>
                        <span>{I18n.t('button_back_label')}</span>
                    </a>
                </div>
                <div className="popup-form__row">
                    <span className="form-title">{I18n.t('forgot_password_title')}</span>
                </div>
                <div className="popup-form__error-hint">{error}</div>
                <div className="popup-form__row">
                    <label htmlFor="field-forgot-email" className="field-label">{I18n.t('email_label')}</label>
                    <div className={`field${error || emailError ? ' field-error' : ''}`}>
                        <div className="field__wrap">
                            <input
                                type="text"
                                className="field__input"
                                id="field-forgot-email"
                                name="egb_user[email]"
                                placeholder={I18n.t('email_placeholder')}/>
                            {this.state.emailError && <InputError error={this.state.emailError} />}
                        </div>
                    </div>
                </div>
                <div className="popup-form__row warning__row">
                    <div className="warning__row-title">
                        <SpriteIcon name="#svg-warning-fill" size={{height: 12, width: 12}} />
                        <span>{I18n.t('forgot_password_warning_title')}</span>
                    </div>
                    <p className="warning__row-description" dangerouslySetInnerHTML={{__html: I18n.t('forgot_password_warning_description')}} />
                    <div className="warning__row-contact-us">
                        <span>{I18n.t('forgot_password_warning_contact_us')}</span>
                        <a href="mailto:support@egb.com">support@egb.com</a>
                    </div>
                </div>
                <div className="popup-form__row captcha__row">
                    {useRecaptchaV2
                        ? <div className={`popup-form__row captcha__row${this.captchaError() ? ' field-error' : ''}`}>
                            <Captcha reset={error} />
                        </div>
                        : null
                    }
                </div>
                {submitting
                    ? <div className="popup-form__submit-row">
                        <SmartLoader loaderClassName="button-adaptive login-loader"/>
                    </div>
                    : <div className="popup-form__submit-row">
                        <input
                            className="button-adaptive"
                            disabled={submitting}
                            type="submit"
                            value={I18n.t('remind_password')} />
                    </div>
                }
                {!submitting &&
                    <div className="popup-form__row text-center">
                        <a href="#" onClick={this.sendMagicLink}>{I18n.t('magic_link_button')}</a>
                    </div>
                }
            </form>;
    }
}

export default withGoogleReCaptcha(ForgotPassword);
